export default "__VITE_ASSET__C5o7TYyw__"